/* unplugin-vue-components disabled */import script from "./HomeView.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeView.vue?vue&type=script&setup=true&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=2770c75c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\SHBK_03_0026\\OneDrive - Microsoft 365\\桌面\\project\\jp-bk-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2770c75c"]])

export default __exports__